const e={name:"name",surname:"surname",phone:"phone",email:"email",agreement:"agreement"},m=["utm_source","utm_medium","utm_campaign","utm_content","utm_term"];export{e as BOOKING_REQUEST_FIELDS,m as UTM_KEYS};
//# sourceMappingURL=BookingRequest.constants.js.map
